import React, { memo } from 'react'
import { Route } from 'react-router-dom'

import HomeContainer from '../../../../containers/HomeContainer'
import { EARN_POINTS_URL } from '../../../../constants/navigation'
import { CONTACT_US_URL } from '../../constants/navigation'
import EarnPointsContainer from '../../containers/EarnPointsContainer'
import ContactUsContainer from '../../containers/ContactUsContainer'

const HomeContainerWrapper = (props) => {
  return (
    <HomeContainer
      {...props}
      additionalRoutes={
        <>
          <Route path={EARN_POINTS_URL} element={<EarnPointsContainer />} />
          <Route path={CONTACT_US_URL} element={<ContactUsContainer />} />
        </>
      }
    />
  )
}

export default memo(HomeContainerWrapper)
